export default __webpack_public_path__ + "static/media/13g28mmn.56baaabc.jpeg";